// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>9</span>&nbsp;&nbsp;They have given freely to the poor;<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;their righteousness stands fast for ever;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;their head will be exalted with honour.<br> </p> </div></div>";
// Exports
module.exports = code;